import React from "react";
import AnimateOnScroll from 'react-animate-on-scroll'; // Import the animation component
import 'animate.css/animate.min.css'; // Import animate.css for animations
import Erth from "./img/—Pngtree—science and technology high-tech earth_5449137 1.png";
import Bulding from "./img/pngegg 1.png";
import Lottie from 'lottie-react';
import animationData from '../Home/lottie/animation_lno36s5l.json';
import './Company.css'


export default function Company() {
  return (
    <section id="company">
      <div className="container" style={{ color: "white", marginTop: '20%', paddingTop: 200 }}>
        <div className="row">
          <div className="col-md-6">
            {/* Content for the first column */}
            <AnimateOnScroll
              animateIn="animate__slideInLeft" // Animation class from animate.css
              animateOnce={true} // Only animate once
            >
              <div className="vertical-line1">
                <h2 className="who_is" style={{ textAlign: "center" }}>
                  Who is LankaTech Innovations?
                </h2>
                <p className="cp1" style={{ fontWeight: 100 }}>
                  Lankatech Innovations is a dynamic and forward-thinking technology
                  company dedicated to pushing the boundaries of innovation. Founded
                  with a vision to transform the digital landscape, we are committed
                  to empowering businesses and individuals with cutting-edge
                  solutions that drive progress and make a positive impact on the
                  world.
                </p>
              </div>
            </AnimateOnScroll>
          </div>
          <div className="col-md-6" id="img-erch">
            {/* Content for the second column */}
            <AnimateOnScroll
              animateIn="animate__fadeIn"
              animateOnce={true}
            >
              <img src={Erth} className="img_earth" alt="Earth" />
            </AnimateOnScroll>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            {/* Content for the second column */}
            <AnimateOnScroll
              animateIn="animate__fadeIn"
              animateOnce={true}
            >
              <img className="img_building" src={Bulding} alt="Earth" />
            </AnimateOnScroll>
          </div>
          <div className="col-md-6" style={{ textAlign: "end" }}>
            {/* Content for the first column */}
            <AnimateOnScroll
              animateIn="animate__slideInRight"
              animateOnce={true}
            >
              <div className="vertical-line2">
                <h2 style={{ textAlign: "center" }}>Our Mission</h2>
                <p style={{ marginTop: 50, textAlign: "justify", fontWeight: 100 }}>
                  At Lankatech Innovations, our mission is to harness the power of
                  technology to solve complex problems, enhance efficiency, and
                  improve lives. We strive to be at the forefront of innovation,
                  constantly exploring new ideas and approaches to create solutions
                  that matter.
                </p>
              </div>
            </AnimateOnScroll>
          </div>
        </div>
      </div>
    </section>
  );
}

